<template>
    <b-container v-if="load.Loading" class="container-basic-spinner">
        <spinner :admin="false" />
    </b-container>
    <b-list-group v-else class="create-task-group">

        <b-list-group-item>

            <b-row class="v-center mt-20">

                <b-col md="6" sm="12" class="mb-20">

                    <custom-multiselect v-model="entity.Category"
                                        :options="todoCategories"
                                        track-by="Id"
                                        label="Name"
                                        placeholder="Выберите категорию"/>
                </b-col>

                <b-col class="mb-20">

                    <b-form-datepicker v-model="entity.PlannedFinishDate"
                                       :min="min"
                                       :initial-date="initialDate"
                                       hide-header
                                       placeholder="Выберите дату" />
                    
                </b-col>

            </b-row>

            <b-row class="m-20-0">

                 <b-form-textarea id="textarea"
                                  v-model="entity.Text"
                                  placeholder="Текст задачи"
                                  rows="6"
                                  class="m-0-15"/>
            </b-row>

        </b-list-group-item>

        <b-list-group-item class="container-button">

            <b-button variant="outline-primary" 
                      class="button-blue mr-15"
                      :class="!entity.IsValid() ? 'invalid' : ''"
                      :disabled="!entity.IsValid()"
                      @click="createTodo">
                Сохранить
            </b-button>

        </b-list-group-item>

    </b-list-group>
</template>

<script>
import '@/assets/styles/client/form/createTask.css'

import AllRoutes from '@/routes/all.routes'

import apiService from '@/services/api.service'
import dialogService from '@/services/dialog.service'

import Loading from '@/store/models/Loading'
import Spinner from '@/components/shared/Spinner'

import CustomMultiselect from '@/components/shared/CustomMultiSelect'

import CreateTaskModel from '@/store/models/client/form/CreateTask'

export default {
    data: function() {
        let load = new Loading();

        let entity = new CreateTaskModel(this.$route.query.tradePointId);

        this.getTodoCategories(load);

        const now = new Date();
        const tomorrow = now.getDate() + 1;

        let initialDate = new Date();
        initialDate.setDate(tomorrow);

        let minDate = new Date();

        return {
            min: minDate,
            initialDate: initialDate,

            load: load,
            entity: entity,
            todoCategories: []
        }
    },
    methods: {
        getTodoCategories: function(load) {
            load.Calculate(true);

            apiService.Client.TradePoints.TodoCategories.GetAll()
                .then(response => {
                    this.todoCategories = response.data;                    
                    load.Calculate(false);
                })
                .catch(error => load.Calculate(false));
        },

        createTodo: function() {

            if(!this.entity.IsValid()) {
                dialogService.showAlert('Предупреждение', 'Заполните все поля');
                return;
            }

            let todoDto = this.entity.mapToDto();
            
            this.load.Calculate(true);

            apiService.Client.TradePoints.TodoCategories.PostUpdate(this.$route.query.auditId, this.$route.query.formId, todoDto)
                .then(response => {
                    this.$router.push(AllRoutes.Client.Form.Index + `?id=${this.$route.query.formId}&auditId=${this.$route.query.auditId}`)
                    this.load.Calculate(false);
                })
                .catch(exception => {
                    this.load.Calculate(false);
                });
        }
    },
    components: {
        Spinner,
        CustomMultiselect
    }
}
</script>